import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaTruck, FaBox, FaWarehouse, FaPhone, FaFileAlt, FaStar, FaWhatsapp, FaInfoCircle, FaWineGlass, FaLightbulb, FaCouch, FaPalette, FaShieldAlt, FaDollarSign, FaUsers, FaClock, FaHandHoldingHeart, FaBalanceScale } from 'react-icons/fa';
import './Services.css';

const Services = () => {
    const [services, setServices] = useState([]);

    useEffect(() => {
        fetchServices();
    }, []);

    const fetchServices = async () => {
        try {
            const response = await axios.get('http://localhost:5000/api/services');
            setServices(response.data);
        } catch (error) {
            console.error('Error fetching services:', error);
        }
    };

    return (
        <div className="services-page">
            <div className="services-header">
                <div className="container">
                    <div className="header-line"></div>
                    <h1>Services</h1>
                    <p>We are the forerunners in the packing and moving business offering matchless and effective relocation services in the household sector.</p>
                </div>
            </div>

            {/* Home Relocation Services */}
            <section className="service-detail-section">
                <div className="container">
                    <div className="service-detail-row">
                        <div className="service-detail-text">
                            <h2>Home Relocation Services</h2>
                            <p>At BK Packers and Movers, we provide reliable and professional home relocation services designed to make your moving experience smooth and stress-free. Whether you are shifting within the city or moving to another state, our experienced team ensures that your household goods are packed, transported, and delivered safely.</p>
                            <p>From packing fragile items like glassware and electronics to handling furniture and appliances, BK Packers and Movers handle everything with utmost care. Our team takes care of packing, loading, transportation, unloading, and unpacking so that you can focus on settling comfortably into your new home.</p>
                            <div className="service-buttons">
                                <a href="tel:8189999775" className="btn-call"><FaPhone /> Call Now</a>
                                <a href="#quote" className="btn-quote"><FaFileAlt /> Get Free Quote</a>
                            </div>
                        </div>
                        <div className="service-detail-image">
                            <img src="/Images/Home_relocation_service.jpeg" alt="Home Relocation" loading="lazy" />
                        </div>
                    </div>

                    {/* Office Shifting Services */}
                    <div className="service-detail-row reverse">
                        <div className="service-detail-text">
                            <h2>Office Shifting Services</h2>
                            <p>BK Packers and Movers provides reliable and efficient office shifting services designed to relocate your business quickly and safely. We understand that office relocation requires careful planning and minimal downtime, which is why our expert team ensures a smooth and organized moving process.</p>
                            <p>At BK Packers and Movers, we focus on completing office relocations on time so your business operations can resume without unnecessary delays. Whether you are moving a small office, corporate workspace, or an entire commercial establishment, we provide customized relocation solutions to meet your needs.</p>
                            <div className="service-buttons">
                                <a href="tel:8189999775" className="btn-call"><FaPhone /> Call Now</a>
                                <a href="#quote" className="btn-quote"><FaFileAlt /> Get Free Quote</a>
                            </div>
                        </div>
                        <div className="service-detail-image">
                            <img src="/Images/office_shifting_service.jpeg" alt="Office Shifting" loading="lazy" />
                        </div>
                    </div>

                    {/* Packing Services */}
                    <div className="service-detail-row">
                        <div className="service-detail-text">
                            <h2>Packing Services</h2>
                            <p>At BK Packers and Movers, we offer professional and secure packing services to ensure that your belongings are safely prepared for relocation. Proper packing plays a crucial role in protecting items during transportation, and our experienced team uses high-quality packing materials and proven techniques to safeguard your valuable goods.</p>
                            <p>Our trained packing specialists carefully handle all types of household and office items, including fragile glassware, electronics, furniture, appliances, and important documents. We use strong cartons, bubble wrap, foam sheets, packing tape, and protective covers to prevent damage during loading, transportation, and unloading.</p>
                            <div className="service-buttons">
                                <a href="tel:8189999775" className="btn-call"><FaPhone /> Call Now</a>
                                <a href="#quote" className="btn-quote"><FaFileAlt /> Get Free Quote</a>
                            </div>
                        </div>
                        <div className="service-detail-image">
                            <img src="/Images/packing_service.jpeg" alt="Packing Services" loading="lazy" />
                        </div>
                    </div>

                    {/* Loading Services */}
                    <div className="service-detail-row reverse">
                        <div className="service-detail-text">
                            <h2>Loading Services</h2>
                            <p>At BK Packers and Movers, we provide professional and safe loading services to ensure that your belongings are handled with care during the moving process. Proper loading is essential to protect items from damage during transportation, and our trained team uses the right techniques and equipment to load your goods securely.</p>
                            <p>With a focus on safety and efficiency, our loading team ensures that every item is placed securely in the transport vehicle. Whether you are moving your home, office, or commercial goods, BK Packers and Movers provides reliable loading services for a smooth relocation experience.</p>
                            <div className="service-buttons">
                                <a href="tel:8189999775" className="btn-call"><FaPhone /> Call Now</a>
                                <a href="#quote" className="btn-quote"><FaFileAlt /> Get Free Quote</a>
                            </div>
                        </div>
                        <div className="service-detail-image">
                            <img src="/Images/loading_service.jpeg" alt="Loading Services" loading="lazy" />
                        </div>
                    </div>

                    {/* Unloading Services */}
                    <div className="service-detail-row">
                        <div className="service-detail-text">
                            <h2>Unloading Services</h2>
                            <p>At BK Packers and Movers, we provide professional and careful unloading services to ensure that your belongings are safely removed from the transport vehicle and placed in your new location without any damage. Our experienced team understands that proper unloading is just as important as packing and loading during the relocation process.</p>
                            <p>We focus on efficiency, safety, and customer satisfaction while unloading your goods. Whether it is a home relocation, office shifting, or commercial move, BK Packers and Movers ensures a smooth and organized unloading process.</p>
                            <div className="service-buttons">
                                <a href="tel:8189999775" className="btn-call"><FaPhone /> Call Now</a>
                                <a href="#quote" className="btn-quote"><FaFileAlt /> Get Free Quote</a>
                            </div>
                        </div>
                        <div className="service-detail-image">
                            <img src="/Images/unloading_service.jpeg" alt="Unloading Services" loading="lazy" />
                        </div>
                    </div>

                    {/* Transportation Services */}
                    <div className="service-detail-row reverse">
                        <div className="service-detail-text">
                            <h2>Transportation Services</h2>
                            <p>At BK Packers and Movers, we provide reliable and secure transportation services to ensure that your goods reach their destination safely and on time. Our well-maintained fleet of vehicles and experienced drivers allow us to handle both local and long-distance transportation with efficiency and care.</p>
                            <p>Whether you are relocating your home, shifting your office, or transporting commercial goods, BK Packers and Movers offers dependable transportation solutions tailored to your needs.</p>
                            <div className="service-buttons">
                                <a href="tel:8189999775" className="btn-call"><FaPhone /> Call Now</a>
                                <a href="#quote" className="btn-quote"><FaFileAlt /> Get Free Quote</a>
                            </div>
                        </div>
                        <div className="service-detail-image">
                            <img src="/Images/transportation_service.jpeg" alt="Transportation Services" loading="lazy" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Packing Materials Section */}
            <section className="packing-materials-section">
                <div className="container">
                    <h2>📦 Packing Materials Used During <span>Home Relocation</span></h2>
                    <p className="subtitle">Packing is not about quantity. It is about suitability.</p>
                    <div className="materials-grid">
                        <div className="material-card">
                            <div className="material-icon"><FaBox /></div>
                            <h4>Multi-size Carton Boxes</h4>
                        </div>
                        <div className="material-card">
                            <div className="material-icon"><FaBox /></div>
                            <h4>Bubble Sheets for Breakables</h4>
                        </div>
                        <div className="material-card">
                            <div className="material-icon"><FaBox /></div>
                            <h4>Foam Layers for Corners</h4>
                        </div>
                        <div className="material-card">
                            <div className="material-icon"><FaBox /></div>
                            <h4>Stretch Film for Furniture</h4>
                        </div>
                        <div className="material-card">
                            <div className="material-icon"><FaBox /></div>
                            <h4>Mattress Covers</h4>
                        </div>
                        <div className="material-card">
                            <div className="material-icon"><FaBox /></div>
                            <h4>Packing Paper for Kitchen</h4>
                        </div>
                    </div>
                    <div className="items-packed-section">
                        <h3>Items Packed Separately to Avoid Pressure Damage</h3>
                        <div className="items-tags">
                            <span className="item-tag"><FaLightbulb className="item-tag-icon" /> Electronics</span>
                            <span className="item-tag"><FaBox className="item-tag-icon" /> Clothes</span>
                            <span className="item-tag"><FaBox className="item-tag-icon" /> Books</span>
                            <span className="item-tag"><FaBox className="item-tag-icon" /> Utensils</span>
                            <span className="item-tag"><FaBox className="item-tag-icon" /> Decor Items</span>
                            <span className="item-tag"><FaBox className="item-tag-icon" /> Appliances</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why BK Packers is Chosen */}
            <section className="why-chosen-section">
                <div className="container">
                    <h2>Why <span>Bk Packers and Movers</span> Is Chosen</h2>
                    <p className="subtitle">People often assume all movers work the same way. The difference shows on moving day. <span>Customers looking for Best Home Relocation Services prefer us because:</span> </p>
                    <div className="why-chosen-grid">
                        <div className="why-chosen-card">
                            <div className="why-chosen-icon"><FaBox /></div>
                            <h4>Room by Room Packing</h4>
                            <p>Packing is done room by room, not randomly. This ensures organized unpacking at your new home.</p>
                        </div>
                        <div className="why-chosen-card">
                            <div className="why-chosen-icon"><FaShieldAlt /></div>
                            <h4>Heavy Items Separately</h4>
                            <p>Heavy items are handled separately with proper equipment and trained personnel.</p>
                        </div>
                        <div className="why-chosen-card">
                            <div className="why-chosen-icon"><FaHandHoldingHeart /></div>
                            <h4>Fragile Goods Care</h4>
                            <p>Fragile goods are not rushed. Extra time and care is given to delicate items.</p>
                        </div>
                        <div className="why-chosen-card">
                            <div className="why-chosen-icon"><FaBox /></div>
                            <h4>Clear Carton Marking</h4>
                            <p>Cartons are marked clearly for easy identification and systematic unpacking.</p>
                        </div>
                        <div className="why-chosen-card">
                            <div className="why-chosen-icon"><FaTruck /></div>
                            <h4>Planned Loading</h4>
                            <p>Loading follows a planned sequence to maximize space and minimize damage risk.</p>
                        </div>
                        <div className="why-chosen-card">
                            <div className="why-chosen-icon"><FaBalanceScale /></div>
                            <h4>Balance & Control</h4>
                            <p>Instead of speed, the focus stays on balance and control throughout the process.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Work Shifting Process */}
            <section className="work-shifting-process-section">
                <div className="container">
                    <h2>Our Work Shifting Process.</h2>
                    <div className="process-flow">
                        <div className="process-step">
                            <div className="process-icon"><FaPhone /></div>
                            <h3>Request Quote</h3>
                            <p>Get instant estimates, compare services, analyze requirements, understand pricing, plan your move.</p>
                        </div>
                        <div className="process-arrow">→</div>
                        <div className="process-step">
                            <div className="process-icon"><FaBox /></div>
                            <h3>Schedule</h3>
                            <p>Book your slot, choose timing, confirm dates, pre-move survey, flexible scheduling options.</p>
                        </div>
                        <div className="process-arrow">→</div>
                        <div className="process-step">
                            <div className="process-icon"><FaTruck /></div>
                            <h3>Pack & Load</h3>
                            <p>Professional packing, quality materials, careful handling, secure loading, inventory management.</p>
                        </div>
                        <div className="process-arrow">→</div>
                        <div className="process-step">
                            <div className="process-icon"><FaTruck /></div>
                            <h3>Deliver</h3>
                            <p>Real-time tracking, safe transit, timely delivery, unpacking assistance, complete satisfaction.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Handling Items That Need Extra Attention */}
            <section className="handling-items-section">
                <div className="container">
                    <h2>🤲 <span>Handling Items That Need Extra Attention</span></h2>
                    <p className="subtitle">Certain household items require patience. These usually include:</p>
                    <div className="handling-items-grid">
                        <div className="handling-item-card">
                            <div className="handling-item-icon"><FaWineGlass /></div>
                            <h4>Glassware</h4>
                            <p>Individual wrapping with bubble sheets and bathroom placement in boxes.</p>
                        </div>
                        <div className="handling-item-card">
                            <div className="handling-item-icon"><FaBox /></div>
                            <h4>Crockery Sets</h4>
                            <p>Layered packing with dividers to prevent contact between pieces.</p>
                        </div>
                        <div className="handling-item-card">
                            <div className="handling-item-icon"><FaCouch /></div>
                            <h4>Wooden Furniture</h4>
                            <p>Stretch film wrapping and corner protection to avoid scratches.</p>
                        </div>
                        <div className="handling-item-card">
                            <div className="handling-item-icon"><FaLightbulb /></div>
                            <h4>Electronic Appliances</h4>
                            <p>Original boxes or custom packing with anti-static materials.</p>
                        </div>
                        <div className="handling-item-card">
                            <div className="handling-item-icon"><FaBox /></div>
                            <h4>Decorative Pieces</h4>
                            <p>Custom coating solutions for unique shapes and sizes.</p>
                        </div>
                        <div className="handling-item-card">
                            <div className="handling-item-icon"><FaPalette /></div>
                            <h4>Artwork & Mirrors</h4>
                            <p>Special flat packing techniques with edge protection.</p>
                        </div>
                    </div>
                    <div className="info-note">
                        <FaInfoCircle /> Extra layers and slower handling are used for such goods to ensure safe delivery.
                    </div>
                </div>
            </section>

            {/* Customer Testimonials */}
            <section className="service-testimonials-section">
                <div className="container">
                    <h2>💬 <span>Customer Testimonials</span></h2>
                    <p className="subtitle">What our customers say about our Home Relocation Services</p>
                    <div className="service-testimonials-grid">
                        <div className="service-testimonial-card">
                            <div className="stars">
                                {[...Array(5)].map((_, i) => <FaStar key={i} />)}
                            </div>
                            <p>"The team did not rush the packing. Everything reached safely."</p>
                            <div className="testimonial-author">
                                <div className="testimonial-avatar"></div>
                                <div>
                                    <h5>Rahul Mehta</h5>
                                    <span>Verified Customer</span>
                                </div>
                            </div>
                        </div>
                        <div className="service-testimonial-card">
                            <div className="stars">
                                {[...Array(5)].map((_, i) => <FaStar key={i} />)}
                            </div>
                            <p>"We found Bk Packers and Movers while searching for home relocation services near me. The process was calm and organised."</p>
                            <div className="testimonial-author">
                                <div className="testimonial-avatar"></div>
                                <div>
                                    <h5>Nandita Ghosh</h5>
                                    <span>Verified Customer</span>
                                </div>
                            </div>
                        </div>
                        <div className="service-testimonial-card">
                            <div className="stars">
                                {[...Array(5)].map((_, i) => <FaStar key={i} />)}
                            </div>
                            <p>"Compared to local movers, their approach was much more planned."</p>
                            <div className="testimonial-author">
                                <div className="testimonial-avatar"></div>
                                <div>
                                    <h5>Prakash Verma</h5>
                                    <span>Verified Customer</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Book Service Section */}
            <section className="book-service-section">
                <div className="container">
                    <h2>Book Home Relocation Services A Bk Packers and Movers</h2>
                    <p>If you are typing and looking for <span>Best Home Relocation Services</span> or <span>Home Relocation Services Near Me</span> or <span>Local Home Relocation Services</span>, you can connect with Bk Packers and Movers.</p>
                    <p className="subtitle">We focus on steady transition, proper packing, and clear coordination so your home relocation stays under control.</p>
                    <div className="book-buttons">
                        <a href="tel:8189999775" className="btn-call-yellow"><FaPhone /> Call Now</a>
                        <a href="https://wa.me/918189999775" className="btn-whatsapp"><FaWhatsapp /> WhatsApp</a>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Services;

